"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authDrawOrderContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.authDrawOrderContract = c.router({
    calcCost: {
        method: 'GET',
        path: '/calc-cost',
        query: zod_1.z.object({
            drawTypeCode: zod_1.z.optional(zod_1.z.string()),
            excludeCompleted: zod_1.z.optional(utils_1.booleanParamSchema),
        }),
        responses: {
            200: zod_1.z.array(models_1.ZTicketDetails),
            404: c.type(),
        },
    },
    getPlayerTickets: {
        method: 'GET',
        path: '/tickets/player',
        query: zod_1.z.object({
            drawTypeCode: zod_1.z.optional(zod_1.z.string()),
            drawTypeGroup: zod_1.z.optional(zod_1.z.string()),
            excludeDrawTypeCodes: zod_1.z.optional(zod_1.z.array(zod_1.z.string())),
            excludeCompleted: zod_1.z.optional(utils_1.booleanParamSchema),
        }),
        responses: {
            200: zod_1.z.array(models_1.ZTicketDetails),
            404: c.type(),
        },
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=drawOrder.auth.contract.js.map